import React, {
  // useState,
  useEffect
} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import Input from '@material-ui/core/Input';
import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import Form from '~/containers/Form';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import useStyles from './styles';
import SpecialtyRecord from '~/records/SpecialtyRecord';
import InputCheckBox from '~/components/Input/InputCheckBox';
import InputNumber from '~/components/Input/InputNumber';

const attrName = (attr) => SpecialtyRecord.hummanAttributeName(attr);

function SpecialtyItem({ record, handleChange, onSubmit, loading }) {
  const classesRoot = useStyles();
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();

  useEffect(() => {
  }, []);

  return (
    <>
      <Form onSubmit={onSubmit} >
        <Paper
          Icon={LocalHospitalIcon}
          iconColor={isPersisted ? 'purple' : 'blue'}
          title={t('specialties.defSingular')}
          loading={loading}
        >
          <div className={clsx(classesRoot.root)}>
            <GridContainer>
              <GridItem xs={12} md={10}>
                <GridContainer>
                  <GridItem xs={12} md={5}>
                    <InputControl
                      name={'name'}
                      value={record.get('name')}
                      label={attrName('name')}
                      required={true}
                      inputComponent={Input}
                      onChange={handleChange}
                    />
                  </GridItem>
                  <GridItem xs={2} sm={2} md={1}>
                    <InputControl
                      value={record.get('is_active')}
                      name="is_active"
                      label={attrName('is_active')}
                      inputComponent={InputCheckBox}
                      onChange={handleChange}
                      InputProps={{
                        styleInput: {marginTop: 30}
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={3}>
                    <InputControl
                      required
                      value={record.get('appointment_duration')}
                      name={'appointment_duration'}
                      label={attrName('appointment_duration')}
                      inputComponent={InputNumber}
                      onChange={handleChange}
                      InputProps={{
                        styleInput: {marginTop: 30},
                        precision: 0,
                        showMask: false,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={3}>
                    <InputControl
                      required
                      value={record.get('appointment_interval')}
                      name={'appointment_interval'}
                      label={attrName('appointment_interval')}
                      inputComponent={InputNumber}
                      onChange={handleChange}
                      InputProps={{
                        styleInput: {marginTop: 30},
                        precision: 0,
                        showMask: false,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={3}>
                    <InputControl
                      value={record.get('external_id_ids')}
                      name={'external_id_ids'}
                      label={attrName('external_id_ids')}
                      inputComponent={Input}
                      onChange={handleChange}
                      InputProps={{
                        inputProps: { maxLength: 12 },
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

SpecialtyItem.propTypes = {
  record: PropTypes.instanceOf(SpecialtyRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

SpecialtyItem.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(SpecialtyItem));
